// extracted by mini-css-extract-plugin
export default {"Wrapper":"CustomerServiceDetails_Wrapper__nxuTX","Header":"CustomerServiceDetails_Header__FRrRo"};